import React, { useState, useEffect } from 'react';
import { Box, Tab, Paper, Button } from '@mui/material';
import Tabs, { tabsClasses } from '@mui/material/Tabs';
import ControlBar from '../components/structure/ControlBar';
import ControlButton from '../components/structure/ControlButton';

import HistoryIcon from '@mui/icons-material/History';
import IllusionDataGrid from '../components/datagrid/FullDataGrid';
import AssetOverviewDataGrid from '../components/datagrid/AssetOverviewDataGrid';
import RightClickMenu from '../components/rightclicks/RightClickMenu';
import AssetDetailDataGrid from '../components/datagrid/AssetDetailDataGrid';
import { bgcolor } from '@mui/system';
import GreenButton from '../components/buttons/GreenButton';

import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ReceiptDataGrid from '../components/datagrid/ReceiptDataGrid';

export default function TranskoderView() {
    const margin = '0px';
    const dynamicHeight = `calc(100% - ${margin})`;
    const boxStyle = { height: dynamicHeight, maxHeight: dynamicHeight, backgroundColor: 'rgba(1,1,1,0.8)'};


    useEffect(() => {
    }, [])

    return (
        <React.Fragment>
            <Box display="flex" flexDirection="column" sx={boxStyle}>
                <ReceiptDataGrid />
            </Box>
        </React.Fragment>
    )
}
